import React from "react";
import './CountriesButton.scss';
import { Link } from "react-router-dom";

function ShowCreateCountry() {
    return(
        <Link className="link--to--country" to="/admin-users/countries">
            <button className="btn-paises">Países</button>
        </Link>
    );
}

export default ShowCreateCountry;